// extracted by mini-css-extract-plugin
module.exports = {"headerBtn":"styles_headerBtn__1AigA","disabled":"styles_disabled__1bKkP","YoelloButton":"styles_YoelloButton__2K_RB"};